import { render, staticRenderFns } from "./ShiftVDPForm.vue?vue&type=template&id=3ed69c42&"
import script from "./ShiftVDPForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftVDPForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports